const updates = [
  {
    title: '《夏日幻境》第7话已更新',
    time: '10分钟前',
    tag: '新番更新',
    dotColor: 'bg-green-500',
  },
  {
    title: '《剑与魔法》第12话已更新',
    time: '35分钟前',
    tag: '热血番',
    dotColor: 'bg-primary-500',
  },
  {
    title: '2026夏季新番专题页面上线',
    time: '2小时前',
    tag: '平台公告',
    dotColor: 'bg-accent-500',
  },
  {
    title: '《星之彼方》第3话已更新',
    time: '3小时前',
    tag: '恋爱番',
    dotColor: 'bg-secondary-500',
  },
  {
    title: '追更日历功能优化升级',
    time: '1天前',
    tag: '功能更新',
    dotColor: 'bg-accent-500',
  },
  {
    title: '《异界食堂》第9话已更新',
    time: '1天前',
    tag: '搞笑番',
    dotColor: 'bg-secondary-500',
  },
  {
    title: '《暗影追踪》第5话已更新',
    time: '2天前',
    tag: '悬疑番',
    dotColor: 'bg-primary-500',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">
            追更快讯
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            最新动漫更新动态，追更动漫快人一步
          </p>
        </div>
        <div className="max-w-2xl mx-auto">
          {updates.map((item, i) => (
            <div key={i} className="relative flex gap-4 pb-6 last:pb-0">
              <div className="flex flex-col items-center flex-shrink-0">
                <div className={`w-3 h-3 rounded-full ${item.dotColor} mt-1.5`}></div>
                {i < updates.length - 1 && (
                  <div className="w-0.5 flex-1 bg-background-300/60 mt-1.5"></div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex flex-wrap items-center gap-2 mb-1">
                  <span className="px-2 py-0.5 rounded-full bg-background-200/70 text-xs text-foreground-600 font-medium">
                    {item.tag}
                  </span>
                  <span className="text-xs text-foreground-500">{item.time}</span>
                </div>
                <p className="text-sm text-foreground-800 font-medium leading-relaxed">
                  {item.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}